<template>
  <div>
    <v-btn
      :loading="loading"
      @click="dialog = true"
      depressed
      color="primary"
      height="40"
      class="rounded-lg text-none body-2"
      >Создать операцию
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="600"
    >
      <v-card class="pa-5">
        <div class="font-weight-bold">Создание операции</div>
        <v-text-field
          dense
          hide-details
          class="mt-5"
          outlined
          label="Сумма"
          type="number"
          v-model.number="data.sum"
        ></v-text-field>
        <v-text-field
          dense
          hide-details
          class="mt-3"
          outlined
          label="Сообщение пользователю"
          v-model="data.message"
        ></v-text-field>
        <v-text-field
          dense
          hide-details
          class="mt-3"
          outlined
          label="Комментарий к операции"
          v-model="data.description"
        ></v-text-field>
        <v-text-field
          v-model="phoneInput"
          label="Пользователи"
          hint="Разделитель: ; или перенос строки"
          :rules="phoneRules"
          multi-line
          rows="3"
        ></v-text-field>
        <!-- <v-autocomplete
          v-model="selectedUsers"
          :loading="userLoading"
          :items="userBalance.list"
          :search-input.sync="searchUser"
          :item-text="v => (v.first_name || 'Неизвестный') + ' - ' + v.phone"
          item-value="id"
          cache-items
          class="mt-4 mb-4"
          flat
          hide-no-data
          hide-details
          multiple
          deletable-chips
          clearable
          @change="onSelect"
          small-chips
          outlined
          dense
          label="Пользователи"
        ></v-autocomplete> -->
        <div>{{ `Выбрано пользователей: ${selectedUsers.length}` }}</div>
        <div
          class="mt-5 primary--text text-body-2"
          v-if="settings && settings.system_settings.max_amount_for_refiled_balance !== null"
        >
          Максимальное количество для начисления:
          {{ settings.system_settings.max_amount_for_refiled_balance }}
        </div>

        <v-btn
          class="mt-5 rounded-lg"
          color="primary"
          depressed
          :disabled="
            !data.sum ||
            !data.message ||
            !data.description ||
            !settings ||
            settings.system_settings.max_amount_for_refiled_balance < data.sum ||
            selectedUsers.length == 0 ||
            validPhones.length === 0
          "
          :loading="$balanceOperation.loadings.save || onLoading"
          @click="save"
          >Создать
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import AuthenticatorInput from '@/admin/components/AuthenticatorInput.vue'
  import { SearchUser } from '@/models/SearchUser'

  export default {
    name: 'CreateUserBalanceButton',
    comments: {
      AuthenticatorInput
    },
    props: {
      settings: Object,
      loading: Boolean,
      onSave: {
        type: Function,
        required: true
      }
    },
    data: () => {
      return {
        phoneInput: '',
        userLoading: true,
        debounceTimer: null,
        userBalance: new SearchUser(),
        dialog: false,
        searchUser: '',
        selectedUsers: [],
        timeout: null,
        requestId: 0,
        onLoading: false,
        data: {
          sum: 0,
          message: null,
          description: null
        }
      }
    },
    computed: {
      validPhones() {
        if (!this.phoneInput || !this.phoneInput.trim()) return []

        return this.phoneInput.split(/\s*[;\r\n]+\s*/).filter(phone => phone !== null)
      },
      phoneErrors() {
        const errors = []

        if (this.parsedPhones.length === 0 && this.phoneInput.trim()) {
          errors.push('Не удалось распознать номера телефонов')
        }

        if (this.invalidPhones.length > 0) {
          errors.push(`Найдено ${this.invalidPhones.length} невалидных номеров`)
        }

        return errors
      },
      phoneRules() {
        return [v => this.validateAllPhones(v)]
      }
    },
    watch: {
      searchUser(v) {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.userBalance.loadList(
            v
              ? {
                  first_name: v
                }
              : null
          )
        }, 300)
      },
      validPhones: {
        handler(newPhones) {
          this.debouncedFetch(newPhones)
        },
        immediate: false
      }
    },
    methods: {
      debouncedFetch(phones) {
        clearTimeout(this.debounceTimer)

        if (phones.length === 0) {
          this.selectedUsers = []
          return
        }

        this.debounceTimer = setTimeout(() => {
          this.fetchUsers(phones)
        }, 500)
      },
      async fetchUsers(phones) {
        const currentRequestId = ++this.requestId

        this.onLoading = true

        try {
          console.log('make request')
          const token = localStorage.getItem('access')
          const response = await axios.post(
            'users/by_phones/',
            { phones },
            {
              headers: {
                Authorization: `Bearer ${token}`
              }
            }
          )

          if (currentRequestId !== this.requestId) return
          this.selectedUsers = response.data
        } catch (error) {
          console.log(`error: ${error}`)
          if (currentRequestId !== this.requestId) return
          this.selectedUsers = []
        } finally {
          if (currentRequestId === this.requestId) {
            this.onLoading = false
          }
        }
      },
      onSelect() {
        this.$nextTick(() => {
          this.searchUser = ''
        })
      },
      onPhoneInput(input) {},
      isValidPhone(phone) {
        const phoneRegex = /^(\+7|8|7)\d{10}$/
        return phoneRegex.test(phone)
      },
      clearData() {
        this.searchUser = ''
        this.selectedUsers = []

        this.data = {
          sum: 0,
          message: null,
          description: null
        }
      },
      save() {
        const result = this.selectedUsers.map(userId => ({
          user: userId,
          sum: this.data.sum,
          message: this.data.message,
          description: this.data.description
        }))

        this.onSave(result)
        this.clearData()
      },
      validateAllPhones(value) {
        if (!value || !value.trim()) return true

        const phones = this.parsePhones(value)

        if (phones.length === 0) {
          return 'Не удалось распознать номера телефонов'
        }

        const invalidCount = phones.filter(p => !this.isValidPhone(p)).length

        if (invalidCount > 0) {
          return `Найдено ${invalidCount} невалидных номеров`
        }

        return true
      },
      parsePhones(input) {
        if (!input || !input.trim()) return []

        return input
          .split(/\s*[;\r\n]+\s*/)
          .map(phone => phone.trim())
          .filter(phone => phone.length > 0)
      },
      close() {
        if (this.dialog) {
          this.dialog = false
        }
      }
    },
    beforeDestroy() {
      this.phoneInput = ''
      clearTimeout(this.debounceTimer)
    },
    mounted() {
      this.userBalance.loadList().finally(() => {
        this.userLoading = false
      })
    }
  }
</script>

<style scoped></style>
